import React, { useState, useEffect, useCallback, useRef } from 'react';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/articulos.php';

/* ── Icons ── */
const IconPlus     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTrash    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconEyeOff   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconStar     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconStarFill = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" width="14" height="14"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconImage    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/><circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/><path d="M21 15l-5-5L5 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconDrag     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M8 6h.01M8 12h.01M8 18h.01M16 6h.01M16 12h.01M16 18h.01" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconLink     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

const CATEGORIAS = ['Lenguaje', 'TEA', 'Habla', 'Aprendizaje', 'Familia', 'Tartamudez', 'Recursos', 'General'];

const FORM_VACIO = {
  titulo: '', resumen: '', contenido: '', imagen_portada: '',
  video_youtube: '', categoria: '', tags: '', autor: 'Comunicar',
  publicado: false, destacado: false,
};

/* ── Estilos inline base ── */
const S = {
  page:     { padding: '1.5rem', maxWidth: 1100, margin: '0 auto', fontFamily: "'DM Sans', sans-serif" },
  header:   { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '.8rem' },
  h1:       { fontSize: '1.4rem', fontWeight: 700, color: '#111614', margin: 0 },
  btn:      { display: 'inline-flex', alignItems: 'center', gap: '.4rem', padding: '.6rem 1.2rem', borderRadius: 100, fontFamily: 'inherit', fontSize: '.85rem', fontWeight: 700, cursor: 'pointer', border: 'none', transition: 'all .2s' },
  btnPrimary: { background: '#111614', color: '#82D8B3' },
  btnGhost:   { background: 'none', border: '1.5px solid rgba(130,216,179,.3)', color: '#5a6a63' },
  btnDanger:  { background: '#fef2f2', border: 'none', color: '#dc2626' },
  card:     { background: '#fff', borderRadius: 14, border: '1.5px solid rgba(130,216,179,.15)', overflow: 'hidden', marginBottom: '.8rem' },
  row:      { display: 'flex', alignItems: 'center', gap: '1rem', padding: '1rem 1.2rem', flexWrap: 'wrap' },
  badge:    { display: 'inline-flex', alignItems: 'center', gap: '.25rem', fontSize: '.7rem', fontWeight: 700, padding: '.2rem .65rem', borderRadius: 100 },
  field:    { display: 'flex', flexDirection: 'column', gap: '.3rem', marginBottom: '.9rem' },
  label:    { fontSize: '.8rem', fontWeight: 600, color: '#111614' },
  input:    { padding: '.7rem 1rem', border: '1.5px solid rgba(130,216,179,.3)', borderRadius: 10, fontFamily: 'inherit', fontSize: '.9rem', color: '#111614', outline: 'none' },
  textarea: { padding: '.7rem 1rem', border: '1.5px solid rgba(130,216,179,.3)', borderRadius: 10, fontFamily: 'inherit', fontSize: '.88rem', color: '#111614', outline: 'none', resize: 'vertical', lineHeight: 1.6 },
  overlay:  { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', overflowY: 'auto', padding: '2rem 1rem' },
  modal:    { background: '#fff', borderRadius: 20, width: '100%', maxWidth: 780, position: 'relative', boxShadow: '0 20px 60px rgba(0,0,0,.2)' },
  modalHead:{ background: '#111614', borderRadius: '20px 20px 0 0', padding: '1.2rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  modalBody:{ padding: '1.5rem', maxHeight: '70vh', overflowY: 'auto' },
  modalFoot:{ padding: '1rem 1.5rem', borderTop: '1px solid #e8f5ef', display: 'flex', justifyContent: 'flex-end', gap: '.6rem' },
  grid2:    { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '.8rem' },
  toast:    { position: 'fixed', bottom: '2rem', right: '2rem', zIndex: 9999, background: '#111614', color: '#fff', borderRadius: 14, padding: '.9rem 1.3rem', display: 'flex', alignItems: 'center', gap: '.7rem', fontSize: '.88rem', fontWeight: 600, boxShadow: '0 8px 32px rgba(0,0,0,.25)' },
};

export default function AdminArticulos() {
  const [articulos,  setArticulos]  = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [busqueda,   setBusqueda]   = useState('');
  const [filtroCat,  setFiltroCat]  = useState('todos');
  const [filtroPub,  setFiltroPub]  = useState('todos');
  const [toast,      setToast]      = useState(null);
  const [modal,      setModal]      = useState(null); // null | 'crear' | 'editar'
  const [artActivo,  setArtActivo]  = useState(null);
  const [form,       setForm]       = useState(FORM_VACIO);
  const [guardando,  setGuardando]  = useState(false);
  const [imagenes,   setImagenes]   = useState([]);
  const [tabModal,   setTabModal]   = useState('info'); // 'info' | 'contenido' | 'galeria'
  const [dragOver,   setDragOver]   = useState(null);
  const [dragId,     setDragId]     = useState(null);
  const portadaRef = useRef();
  const galeriaRef = useRef();

  const showToast = (msg, tipo = 'ok') => {
    setToast({ msg, tipo });
    setTimeout(() => setToast(null), 3000);
  };

  const fetch_ = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=admin_list`);
      const j = await r.json();
      if (j.success) setArticulos(j.data || []);
    } catch { showToast('Error cargando artículos', 'error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetch_(); }, [fetch_]);

  /* Filtrar */
  const filtrados = articulos.filter(a => {
    const q = busqueda.toLowerCase();
    const matchBus = !q || a.titulo?.toLowerCase().includes(q) || a.categoria?.toLowerCase().includes(q);
    const matchCat = filtroCat === 'todos' || a.categoria === filtroCat;
    const matchPub = filtroPub === 'todos'
      || (filtroPub === 'publicados' && a.publicado)
      || (filtroPub === 'borradores' && !a.publicado);
    return matchBus && matchCat && matchPub;
  });

  /* Abrir modal crear */
  const abrirCrear = () => {
    setArtActivo(null);
    setForm(FORM_VACIO);
    setImagenes([]);
    setTabModal('info');
    setModal('crear');
  };

  /* Abrir modal editar */
  const abrirEditar = async (art) => {
    setArtActivo(art);
    setForm({
      titulo:         art.titulo         || '',
      resumen:        art.resumen        || '',
      contenido:      art.contenido      || '',
      imagen_portada: art.imagen_portada || '',
      video_youtube:  art.video_youtube  || '',
      categoria:      art.categoria      || '',
      tags:           Array.isArray(art.tags) ? art.tags.join(', ') : '',
      autor:          art.autor          || 'Comunicar',
      publicado:      !!art.publicado,
      destacado:      !!art.destacado,
    });
    // Cargar imágenes de galería
    try {
      const r = await fetch(`${API}?action=detail&slug=${art.slug}`);
      const j = await r.json();
      setImagenes(j.data?.imagenes || []);
    } catch { setImagenes([]); }
    setTabModal('info');
    setModal('editar');
  };

  const setF = (k, v) => setForm(p => ({ ...p, [k]: v }));

  /* Guardar */
  const guardar = async () => {
    if (!form.titulo.trim()) { showToast('El título es obligatorio', 'error'); return; }
    setGuardando(true);
    try {
      const action = modal === 'crear' ? 'crear' : 'editar';
      const body   = modal === 'editar' ? { ...form, id: artActivo.id } : form;
      const r = await fetch(`${API}?action=${action}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(modal === 'crear' ? 'Artículo creado' : 'Artículo actualizado');
      if (modal === 'crear' && j.data?.id) {
        setArtActivo({ ...form, id: j.data.id, slug: j.data.slug });
        setModal('editar');
      } else {
        setModal(null); // ← cierra el modal al editar
      }
      fetch_();
    } catch (e) { showToast(e.message, 'error'); }
    finally { setGuardando(false); }
  };

  /* Toggle publicado */
  const togglePub = async (art) => {
    try {
      const r = await fetch(`${API}?action=toggle_publicado`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: art.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setArticulos(as => as.map(a => a.id === art.id ? { ...a, publicado: !a.publicado } : a));
      showToast(art.publicado ? 'Artículo despublicado' : 'Artículo publicado');
    } catch (e) { showToast(e.message, 'error'); }
  };

  /* Toggle destacado */
  const toggleDest = async (art) => {
    try {
      const r = await fetch(`${API}?action=toggle_destacado`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: art.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setArticulos(as => as.map(a => a.id === art.id ? { ...a, destacado: !a.destacado } : a));
    } catch (e) { showToast(e.message, 'error'); }
  };

  /* Eliminar */
  const eliminar = async (art) => {
    if (!window.confirm(`¿Eliminar "${art.titulo}"? Esta acción no se puede deshacer.`)) return;
    try {
      const r = await fetch(`${API}?action=eliminar`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: art.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Artículo eliminado');
      fetch_();
    } catch (e) { showToast(e.message, 'error'); }
  };

  /* Subir portada */
  const subirPortada = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append('imagen', file);
    if (artActivo?.id) fd.append('articulo_id', artActivo.id);
    try {
      const r = await fetch(`${API}?action=subir_portada`, { method: 'POST', body: fd });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setF('imagen_portada', j.data.url);
      showToast('Portada subida');
    } catch (e) { showToast(e.message, 'error'); }
  };

  /* Subir imagen galería */
  const subirGaleria = async (file) => {
    if (!file || !artActivo?.id) { showToast('Guarda el artículo primero', 'error'); return; }
    const fd = new FormData();
    fd.append('imagen', file);
    fd.append('articulo_id', artActivo.id);
    try {
      const r = await fetch(`${API}?action=subir_imagen_galeria`, { method: 'POST', body: fd });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setImagenes(imgs => [...imgs, j.data]);
      showToast('Imagen agregada a la galería');
    } catch (e) { showToast(e.message, 'error'); }
  };

  /* Eliminar imagen galería */
  const eliminarImagen = async (img) => {
    try {
      const r = await fetch(`${API}?action=eliminar_imagen`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: img.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setImagenes(imgs => imgs.filter(i => i.id !== img.id));
      showToast('Imagen eliminada');
    } catch (e) { showToast(e.message, 'error'); }
  };

  /* Drag & drop orden artículos */
  const onDragStart = (id) => setDragId(id);
  const onDragOver  = (e, id) => { e.preventDefault(); setDragOver(id); };
  const onDrop      = async (targetId) => {
    if (!dragId || dragId === targetId) { setDragId(null); setDragOver(null); return; }
    const arr  = [...articulos];
    const from = arr.findIndex(a => a.id === dragId);
    const to   = arr.findIndex(a => a.id === targetId);
    const [item] = arr.splice(from, 1);
    arr.splice(to, 0, item);
    setArticulos(arr);
    setDragId(null);
    setDragOver(null);
    try {
      await fetch(`${API}?action=reordenar`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids: arr.map(a => a.id) }),
      });
      showToast('Orden guardado');
    } catch { showToast('Error guardando orden', 'error'); }
  };

  return (
    <div style={S.page}>

      {/* Toast */}
      {toast && (
        <div style={{ ...S.toast, borderLeft: `4px solid ${toast.tipo === 'ok' ? '#82D8B3' : '#dc2626'}` }}>
          {toast.tipo === 'ok' ? <IconCheck/> : '⚠️'} {toast.msg}
        </div>
      )}

      {/* Header */}
      <div style={S.header}>
        <div>
          <h1 style={S.h1}>📝 Artículos</h1>
          <p style={{ fontSize: '.82rem', color: '#5a6a63', margin: '.2rem 0 0' }}>
            {articulos.length} artículos · {articulos.filter(a => a.publicado).length} publicados
          </p>
        </div>
        <button style={{ ...S.btn, ...S.btnPrimary }} onClick={abrirCrear}>
          <IconPlus/> Nuevo artículo
        </button>
      </div>

      {/* Toolbar */}
      <div style={{ display: 'flex', gap: '.6rem', marginBottom: '1rem', flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem', background: '#fff', border: '1.5px solid rgba(130,216,179,.3)', borderRadius: 10, padding: '.5rem .9rem', flex: 1, minWidth: 180 }}>
          <IconSearch/>
          <input
            type="text" placeholder="Buscar artículo…"
            value={busqueda} onChange={e => setBusqueda(e.target.value)}
            style={{ border: 'none', outline: 'none', fontFamily: 'inherit', fontSize: '.88rem', color: '#111614', width: '100%', background: 'transparent' }}
          />
        </div>
        <select
          value={filtroCat} onChange={e => setFiltroCat(e.target.value)}
          style={{ ...S.input, padding: '.5rem .9rem', cursor: 'pointer' }}
        >
          <option value="todos">Todas las categorías</option>
          {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        {['todos','publicados','borradores'].map(f => (
          <button key={f}
            style={{ ...S.btn, ...(filtroPub === f ? S.btnPrimary : S.btnGhost), padding: '.5rem .9rem' }}
            onClick={() => setFiltroPub(f)}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      {/* Lista */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#5a6a63' }}>Cargando artículos…</div>
      ) : filtrados.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#5a6a63' }}>
          {articulos.length === 0 ? 'Aún no hay artículos. ¡Crea el primero!' : 'Sin resultados para esta búsqueda.'}
        </div>
      ) : filtrados.map(art => (
        <div key={art.id}
          style={{ ...S.card, opacity: !art.publicado ? .75 : 1, outline: dragOver === art.id ? '2px dashed #82D8B3' : 'none' }}
          draggable
          onDragStart={() => onDragStart(art.id)}
          onDragOver={e => onDragOver(e, art.id)}
          onDrop={() => onDrop(art.id)}
        >
          <div style={S.row}>
            {/* Drag handle */}
            <div style={{ color: '#ccc', cursor: 'grab', flexShrink: 0 }}><IconDrag/></div>

            {/* Imagen */}
            {art.imagen_portada
              ? <img src={art.imagen_portada} alt="" style={{ width: 60, height: 50, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }}/>
              : <div style={{ width: 60, height: 50, borderRadius: 8, background: '#edfaf4', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#82D8B3' }}><IconImage/></div>
            }

            {/* Info */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', flexWrap: 'wrap' }}>
                <strong style={{ fontSize: '.95rem', color: '#111614' }}>{art.titulo}</strong>
                {art.destacado && <span style={{ ...S.badge, background: '#fef3c7', color: '#92400e' }}><IconStarFill/> Destacado</span>}
                <span style={{ ...S.badge, background: art.publicado ? '#d1fae5' : '#f3f4f6', color: art.publicado ? '#065f46' : '#6b7280' }}>
                  {art.publicado ? '● Publicado' : '○ Borrador'}
                </span>
                {art.categoria && <span style={{ ...S.badge, background: '#edfaf4', color: '#4db88a' }}>{art.categoria}</span>}
              </div>
              {art.resumen && <p style={{ fontSize: '.78rem', color: '#5a6a63', margin: '.2rem 0 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{art.resumen}</p>}
              <div style={{ fontSize: '.7rem', color: '#9ca3af', marginTop: '.2rem' }}>
                {art.vistas || 0} vistas · {new Date(art.created_at).toLocaleDateString('es-PE')}
                {art.tags?.length > 0 && ` · #${art.tags.slice(0,3).join(' #')}`}
              </div>
            </div>

            {/* Acciones */}
            <div style={{ display: 'flex', gap: '.4rem', flexShrink: 0 }}>
              <button style={{ ...S.btn, padding: '.4rem .7rem', background: art.publicado ? '#edfaf4' : '#f3f4f6', color: art.publicado ? '#065f46' : '#6b7280', border: 'none' }}
                onClick={() => togglePub(art)} title={art.publicado ? 'Despublicar' : 'Publicar'}>
                {art.publicado ? <IconEye/> : <IconEyeOff/>}
              </button>
              <button style={{ ...S.btn, padding: '.4rem .7rem', background: 'none', border: 'none', color: art.destacado ? '#f59e0b' : '#ccc' }}
                onClick={() => toggleDest(art)} title="Destacar">
                {art.destacado ? <IconStarFill/> : <IconStar/>}
              </button>
              <button style={{ ...S.btn, padding: '.4rem .7rem', background: '#edfaf4', color: '#4db88a', border: 'none' }}
                onClick={() => abrirEditar(art)} title="Editar">
                <IconEdit/>
              </button>
              <button style={{ ...S.btn, padding: '.4rem .7rem', ...S.btnDanger }}
                onClick={() => eliminar(art)} title="Eliminar">
                <IconTrash/>
              </button>
            </div>
          </div>
        </div>
      ))}

      {/* ══ MODAL ══ */}
      {modal && (
        <div style={S.overlay} onClick={() => setModal(null)}>
          <div style={S.modal} onClick={e => e.stopPropagation()}>

            {/* Head */}
            <div style={S.modalHead}>
              <h2 style={{ margin: 0, fontSize: '1rem', fontWeight: 700, color: '#82D8B3' }}>
                {modal === 'crear' ? '✏️ Nuevo artículo' : `✏️ Editar: ${artActivo?.titulo?.slice(0,40)}…`}
              </h2>
              <button style={{ background: 'none', border: 'none', color: '#82D8B3', cursor: 'pointer' }} onClick={() => setModal(null)}>
                <IconClose/>
              </button>
            </div>

            {/* Tabs */}
            <div style={{ display: 'flex', borderBottom: '1px solid #e8f5ef', padding: '0 1.5rem', background: '#fafffe' }}>
              {[['info','📋 Información'],['contenido','📄 Contenido'],['galeria','🖼 Galería']].map(([tab, label]) => (
                <button key={tab}
                  style={{ padding: '.7rem 1rem', border: 'none', background: 'none', fontFamily: 'inherit', fontSize: '.82rem', fontWeight: tabModal === tab ? 700 : 400, color: tabModal === tab ? '#4db88a' : '#5a6a63', borderBottom: tabModal === tab ? '2px solid #4db88a' : '2px solid transparent', cursor: 'pointer', marginBottom: -1 }}
                  onClick={() => setTabModal(tab)}
                >{label}</button>
              ))}
            </div>

            <div style={S.modalBody}>

              {/* ── Tab Info ── */}
              {tabModal === 'info' && (
                <>
                  <div style={S.field}>
                    <label style={S.label}>Título <span style={{ color: '#dc2626' }}>*</span></label>
                    <input style={S.input} value={form.titulo} onChange={e => setF('titulo', e.target.value)} placeholder="Título del artículo"/>
                  </div>
                  <div style={S.field}>
                    <label style={S.label}>Resumen / extracto</label>
                    <textarea style={{ ...S.textarea, height: 70 }} value={form.resumen} onChange={e => setF('resumen', e.target.value)} placeholder="Breve descripción para el listado (máx. 200 caracteres)"/>
                  </div>
                  <div style={S.grid2}>
                    <div style={S.field}>
                      <label style={S.label}>Categoría</label>
                      <select style={{ ...S.input, cursor: 'pointer' }} value={form.categoria} onChange={e => setF('categoria', e.target.value)}>
                        <option value="">Sin categoría</option>
                        {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div style={S.field}>
                      <label style={S.label}>Autor</label>
                      <input style={S.input} value={form.autor} onChange={e => setF('autor', e.target.value)} placeholder="Comunicar"/>
                    </div>
                  </div>
                  <div style={S.field}>
                    <label style={S.label}>Tags (separados por coma)</label>
                    <input style={S.input} value={form.tags} onChange={e => setF('tags', e.target.value)} placeholder="lenguaje, TEA, fonología…"/>
                  </div>

                  {/* Imagen portada */}
                  <div style={S.field}>
                    <label style={S.label}>Imagen de portada</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                      {form.imagen_portada
                        ? <img src={form.imagen_portada} alt="portada" style={{ height: 80, borderRadius: 8, objectFit: 'cover', border: '1.5px solid rgba(130,216,179,.3)' }}/>
                        : <div style={{ width: 80, height: 80, borderRadius: 8, background: '#edfaf4', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#82D8B3', flexShrink: 0 }}><IconImage/></div>
                      }
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '.4rem' }}>
                        <label style={{ ...S.btn, ...S.btnPrimary, cursor: 'pointer' }}>
                          📁 {form.imagen_portada ? 'Cambiar portada' : 'Subir portada'}
                          <input ref={portadaRef} type="file" accept="image/*" style={{ display: 'none' }}
                            onChange={e => subirPortada(e.target.files[0])}/>
                        </label>
                        {form.imagen_portada && (
                          <button style={{ ...S.btn, fontSize: '.72rem', color: '#dc2626', border: '1px solid #fecaca', background: 'none' }}
                            onClick={() => setF('imagen_portada', '')}>🗑 Quitar</button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Video YouTube */}
                  <div style={S.field}>
                    <label style={S.label}><IconLink/> Video YouTube (opcional)</label>
                    <input style={S.input} value={form.video_youtube} onChange={e => setF('video_youtube', e.target.value)} placeholder="https://youtu.be/... o ID del video"/>
                    {form.video_youtube && (
                      <div style={{ marginTop: '.5rem', borderRadius: 10, overflow: 'hidden', aspectRatio: '16/9', maxWidth: 360 }}>
                        <iframe
                          src={`https://www.youtube.com/embed/${form.video_youtube.replace(/.*(?:youtu\.be\/|v=)([^&]+).*/, '$1')}`}
                          style={{ width: '100%', height: '100%', border: 'none' }}
                          allowFullScreen title="preview"
                        />
                      </div>
                    )}
                  </div>

                  {/* Checks */}
                  <div style={{ display: 'flex', gap: '1.5rem', marginTop: '.5rem' }}>
                    {[['publicado', '✅ Publicado'], ['destacado', '⭐ Destacado']].map(([key, label]) => (
                      <label key={key} style={{ display: 'flex', alignItems: 'center', gap: '.4rem', fontSize: '.85rem', cursor: 'pointer', fontFamily: 'inherit' }}>
                        <input type="checkbox" checked={!!form[key]} onChange={e => setF(key, e.target.checked)} style={{ accentColor: '#4db88a' }}/>
                        {label}
                      </label>
                    ))}
                  </div>
                </>
              )}

              {/* ── Tab Contenido ── */}
              {tabModal === 'contenido' && (
                <div style={S.field}>
                  <label style={S.label}>Contenido del artículo</label>
                  <p style={{ fontSize: '.75rem', color: '#5a6a63', marginBottom: '.5rem' }}>
                    Puedes usar HTML básico: &lt;h2&gt;, &lt;p&gt;, &lt;strong&gt;, &lt;em&gt;, &lt;ul&gt;, &lt;li&gt;, &lt;a&gt;, &lt;img&gt;
                  </p>
                  <textarea
                    style={{ ...S.textarea, height: 420, fontFamily: 'monospace', fontSize: '.82rem' }}
                    value={form.contenido}
                    onChange={e => setF('contenido', e.target.value)}
                    placeholder="<h2>Introducción</h2>&#10;<p>Escribe el contenido aquí...</p>"
                  />
                  {/* Preview básico */}
                  {form.contenido && (
                    <div style={{ marginTop: '1rem' }}>
                      <p style={{ fontSize: '.75rem', fontWeight: 700, color: '#5a6a63', marginBottom: '.4rem' }}>PREVIEW:</p>
                      <div
                        style={{ background: '#f9fffe', border: '1px solid rgba(130,216,179,.2)', borderRadius: 10, padding: '1rem', fontSize: '.88rem', lineHeight: 1.7, color: '#111614', maxHeight: 250, overflowY: 'auto' }}
                        dangerouslySetInnerHTML={{ __html: form.contenido }}
                      />
                    </div>
                  )}
                </div>
              )}

              {/* ── Tab Galería ── */}
              {tabModal === 'galeria' && (
                <div>
                  {!artActivo?.id && (
                    <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10, padding: '1rem', fontSize: '.85rem', color: '#92400e', marginBottom: '1rem' }}>
                      ⚠️ Guarda el artículo primero para poder agregar imágenes a la galería.
                    </div>
                  )}
                  {artActivo?.id && (
                    <label style={{ ...S.btn, ...S.btnPrimary, cursor: 'pointer', marginBottom: '1rem', display: 'inline-flex' }}>
                      <IconImage/> Agregar imagen a galería
                      <input ref={galeriaRef} type="file" accept="image/*" style={{ display: 'none' }}
                        onChange={e => subirGaleria(e.target.files[0])}/>
                    </label>
                  )}
                  {imagenes.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '2rem', color: '#9ca3af' }}>Sin imágenes en la galería</div>
                  ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '.7rem' }}>
                      {imagenes.map(img => (
                        <div key={img.id} style={{ position: 'relative', borderRadius: 10, overflow: 'hidden', border: '1.5px solid rgba(130,216,179,.2)', aspectRatio: '1' }}>
                          <img src={img.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                          <button
                            style={{ position: 'absolute', top: 4, right: 4, background: 'rgba(220,38,38,.85)', border: 'none', color: '#fff', borderRadius: '50%', width: 24, height: 24, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.7rem' }}
                            onClick={() => eliminarImagen(img)}
                          >✕</button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Footer */}
            <div style={S.modalFoot}>
              <button style={{ ...S.btn, ...S.btnGhost }} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...S.btn, ...S.btnPrimary }} onClick={guardar} disabled={guardando}>
                {guardando ? 'Guardando…' : <><IconCheck/> {modal === 'crear' ? 'Crear artículo' : 'Guardar cambios'}</>}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}